import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { JwtRequestService } from '../../../jwt-request.service';

declare var XLSX: any;


@Component({
  selector: 'app-tramite-anexo-ocho',
  templateUrl: './tramite-anexo-ocho.component.html',
  styleUrls: ['./tramite-anexo-ocho.component.css']
})
export class TramiteAnexoOchoComponent implements OnInit {
  tramiteForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  warningMessage = '';
  showLoadingOverlay = false;

  total_carreras = 0;
  total_periodos = 0;
  total_inscripciones = 0;
  total_reinscripciones = 0;

  data_tabla: any[] = [];
  alumnosConFaltantes: any[] = [];

  anio_seleccionado = '';

  anios = [
    { valor: ''    , nombre: 'Seleccione Ciclo' },
    { valor: '2025', nombre: '2025' },
    { valor: '2026', nombre: '2026' }
  ];

  showAlumnosModal = false;
  showFaltantesModal = false;
  alumnosData: any[] = [];
  modalTitle = '';
  faltantesModalTitle = '';
  selectedItem: any = null;

  constructor(
    private fb: FormBuilder,
    private jwtRequest: JwtRequestService,
    private router: Router
  ) {
    this.tramiteForm = this.createForm();
  }

  ngOnInit(): void {
    this.inicializarDatos();
  }

  createForm(): FormGroup {
    return this.fb.group({
      anio_preliminar: ['']
    });
  }

  inicializarDatos(): void {
    this.total_carreras = 0;
    this.total_periodos = 0;
    this.total_inscripciones = 0;
    this.total_reinscripciones = 0;
    this.data_tabla = [];
    this.alumnosConFaltantes = [];
    this.warningMessage = '';
  }

  consultarPreliminar(): void {
    this.anio_seleccionado = this.tramiteForm.get('anio_preliminar')?.value;

    if (!this.anio_seleccionado) {
      this.errorMessage = 'Por favor seleccione un año';
      this.scrollToTop();
      return;
    }

    this.isLoading = true;
    this.showLoadingOverlay = true;
    this.errorMessage = '';
    this.successMessage = '';
    this.warningMessage = '';

    const payload = {
      anio: this.anio_seleccionado
    };

    this.jwtRequest.post('preliminar-anexo-ocho', payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            this.successMessage = response.messages || 'Consulta realizada exitosamente';
            this.procesarDatosPreliminares(response.data);
          } else {
            this.errorMessage = response.messages || 'Error al consultar datos preliminares';
          }
          this.scrollToTop();
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorMessage = error.error.messages;
          } else {
            this.errorMessage = 'Error de conexión al consultar datos preliminares';
          }
          this.scrollToTop();
        }
      });
  }

  procesarDatosPreliminares(data: any): void {
    if (data) {
      this.total_carreras = data.total_carreras || 0;
      this.total_periodos = data.total_periodos || 0;
      this.total_inscripciones = data.total_inscripciones || 0;
      this.total_reinscripciones = data.total_reinscripciones || 0;
      this.data_tabla = data.detalle || [];
      this.alumnosConFaltantes = data.alumnos_con_faltantes || [];
      
      if (this.alumnosConFaltantes.length > 0) {
        this.warningMessage = `Existen ${this.alumnosConFaltantes.length} alumnos con información faltante`;
      }
    } else {
      this.inicializarDatos();
    }
  }

  generarAnexoOcho(): void {
    this.anio_seleccionado = this.tramiteForm.get('anio_preliminar')?.value;

    if (!this.anio_seleccionado) {
      this.errorMessage = 'Por favor seleccione un año';
      this.scrollToTop();
      return;
    }

    if (this.alumnosConFaltantes.length > 0) {
      this.errorMessage = 'No es posible generar el Anexo 8 mientras existan alumnos con información faltante';
      this.scrollToTop();
      return;
    }

    const confirmacion = confirm(`¿Confirma generar el registro para el año ${this.anio_seleccionado}?`);
    
    if (!confirmacion) {
      return;
    }

    this.isLoading = true;
    this.showLoadingOverlay = true;
    this.errorMessage = '';
    this.successMessage = '';

    const payload = {
      anio: this.anio_seleccionado
    };

    this.jwtRequest.post('generar-anexo-ocho', payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          
          if (response.status === 200) {
            this.successMessage = response.messages || 'Anexo 8 generado exitosamente';
          } else {
            this.errorMessage = response.messages || 'Error al generar el anexo 8';
          }
          this.scrollToTop();
        },
        error: (error) => {
          this.isLoading = false;
          this.showLoadingOverlay = false;
          if (error.error && error.error.messages) {
            this.errorMessage = error.error.messages;
          } else {
            this.errorMessage = 'Error de conexión al generar el anexo 8';
          }
          this.scrollToTop();
        }
      });
  }

  abrirModalAlumnos(item: any): void {
    this.selectedItem = item;
    this.modalTitle = `${item.programa_academico || ''}   |   ${item.periodo || ''}`;
    
    this.isLoading = true;
    this.showLoadingOverlay = true;
    
    setTimeout(() => {
      this.alumnosData = item.alumnos || [];
      
      this.isLoading = false;
      this.showLoadingOverlay = false;
      this.showAlumnosModal = true;
    }, 500);
  }

  cerrarModalAlumnos(): void {
    this.showAlumnosModal = false;
    this.alumnosData = [];
    this.selectedItem = null;
    this.modalTitle = '';
  }

  abrirModalFaltantes(): void {
    this.faltantesModalTitle = `Alumnos con información faltante (${this.alumnosConFaltantes.length})`;
    
    this.isLoading = true;
    this.showLoadingOverlay = true;
    
    setTimeout(() => {
      this.alumnosData = [...this.alumnosConFaltantes];
      
      this.isLoading = false;
      this.showLoadingOverlay = false;
      this.showFaltantesModal = true;
    }, 500);
  }

  cerrarModalFaltantes(): void {
    this.showFaltantesModal = false;
    this.alumnosData = [];
    this.faltantesModalTitle = '';
  }

  exportarExcel(item_master: any): void {
    console.log('Exportar Excel para:', item_master);
    console.log('Programa académico:', item_master.programa_academico);
    console.log('Periodo:', item_master.periodo);
    console.log('Datos alumnos:', item_master.alumnos || []);

    const worksheetData: any[] = [];

    item_master.alumnos.forEach(item => {
      let alumno = item;  
      console.log('>>>>>>  >>>> >>>> ALUMNO :', alumno);
       
      worksheetData.push({
        'Estatus': alumno.estatus,
        'Año del ciclo escolar': alumno.anio_ciclo_escolar,
        'Nombre del alumno': alumno.nombre_alumno,
        'Primer Apellido': alumno.primer_apellido,
        'Segundo Apellido': alumno.segundo_apellido,
        'Género': alumno.genero,
        'CURP': alumno.curp,
        'Fecha de Nacimiento': alumno.fecha_nacimiento,
        'País de Nacimiento': alumno.pais_nacimiento,
        'Entidad Federativa o Ciudad de Nacimiento': alumno.entidad_federativa,
        'País de Procedencia': alumno.pais_procedencia,
        'Idioma/Lengua': alumno.idioma,
        'Necesidad Educativa Especial': alumno.necesidad_educativa_especial,
        'Presenta Antecedente Académico': alumno.presenta_antecedente_academico,
        'CCT': alumno.cct,
        'Matrícula Institucional': alumno.matricula_institucional,
        'Nivel Educativo': alumno.nivel_educativo,
        'Clave de la Institución': alumno.nivel_educativo,
        'Clave de Carrera': alumno.clave_carrera,
        'Turno': alumno.turno,
        'Número de Acuerdo de RVOE': alumno.numero_acuerdo_rvoe,
        'Fecha de Acuerdo de RVOE': alumno.fecha_acuerdo_rvoe,
        'Modalidad Educativa': alumno.modalidad_educativa
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      
    const columnWidths = Object.keys(worksheetData[0]).map(key => {
      const maxLength = worksheetData.reduce((max, row) => {
        const val = row[key] ? row[key].toString() : '';
        return Math.max(max, val.length);
      }, key.length);
      return { wch: maxLength + 2 };
    });
      
    worksheet['!cols'] = columnWidths;
      
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, ''+item_master.ciclo+'_'+item_master.rvoe);
    XLSX.writeFile(workbook, 'BLOQUE_ANEXO_8_'+item_master.ciclo+'_'+item_master.rvoe+'_'+item_master.periodo+'.xlsx');
  }

  exportarExcelFaltantes(): void {
    console.log('Exportar Excel para alumnos con información faltante');
    console.log('Datos alumnos faltantes:', this.alumnosConFaltantes);

    const worksheetData: any[] = [];

    this.alumnosConFaltantes.forEach(alumno => {
      console.log('>>>>>> ALUMNO FALTANTE :', alumno);
       
      worksheetData.push({
        'Estatus': alumno.estatus,
        'Año del ciclo escolar': alumno.anio_ciclo_escolar,
        'Nombre del alumno': alumno.nombre_alumno,
        'Primer Apellido': alumno.primer_apellido,
        'Segundo Apellido': alumno.segundo_apellido,
        'Género': alumno.genero,
        'CURP': alumno.curp,
        'Fecha de Nacimiento': alumno.fecha_nacimiento,
        'País de Nacimiento': alumno.pais_nacimiento,
        'Entidad Federativa o Ciudad de Nacimiento': alumno.entidad_federativa,
        'País de Procedencia': alumno.pais_procedencia,
        'Idioma/Lengua': alumno.idioma,
        'Necesidad Educativa Especial': alumno.necesidad_educativa_especial,
        'Presenta Antecedente Académico': alumno.presenta_antecedente_academico,
        'CCT': alumno.cct,
        'Matrícula Institucional': alumno.matricula_institucional,
        'Nivel Educativo': alumno.nivel_educativo,
        'Clave de la Institución': alumno.nivel_educativo,
        'Clave de Carrera': alumno.clave_carrera,
        'Turno': alumno.turno,
        'Número de Acuerdo de RVOE': alumno.numero_acuerdo_rvoe,
        'Fecha de Acuerdo de RVOE': alumno.fecha_acuerdo_rvoe,
        'Modalidad Educativa': alumno.modalidad_educativa
      });
    });

    if (worksheetData.length > 0) {
      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        
      const columnWidths = Object.keys(worksheetData[0]).map(key => {
        const maxLength = worksheetData.reduce((max, row) => {
          const val = row[key] ? row[key].toString() : '';
          return Math.max(max, val.length);
        }, key.length);
        return { wch: maxLength + 2 };
      });
        
      worksheet['!cols'] = columnWidths;
        
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumnos_Faltantes');
      XLSX.writeFile(workbook, 'ALUMNOS_CON_INFORMACION_FALTANTE_' + this.anio_seleccionado + '.xlsx');
    }
  }

  private scrollToTop(): void {
    setTimeout(() => {
      const contentScrollable = document.querySelector('.content-scrollable');
      if (contentScrollable) {
        contentScrollable.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 100);
  }
}